import { render, staticRenderFns } from "./NumberField.vue?vue&type=template&id=87ea179e&scoped=true&"
import script from "./NumberField.vue?vue&type=script&lang=js&"
export * from "./NumberField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87ea179e",
  null
  
)

export default component.exports